import { create } from 'zustand';
import { countRichiesteAttive } from '../api/richieste';

interface RichiesteCountState {
  count: number;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export const useRichiesteCountStore = create<RichiesteCountState>((set) => ({
  count: 0,
  isLoading: false,
  refetch: async () => {
    set({ isLoading: true });
    try {
      const count = await countRichiesteAttive();
      set({ count, isLoading: false });
    } catch {
      set({ isLoading: false });
    }
  },
}));
